import React, { useEffect, useRef, useState } from 'react';
import CockpitBoard from '@/components/CockpitBoard';
import { CockpitStatus } from '@/utils/type';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { HttpStatusCode } from '@/fetch/core/constant';
const CockpitBoardGroup = () => {
  const timerRef = useRef<any>(null);
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const [cockpitList, setCockpitList] = useState<any>({
    workCockpitList: [],
    restCockpitList: [],
    offlineCockpitList: [],
  });

  const getCockpitGroup = () => {
    if (!newCommon.cockpitTeamNumber) {
      return;
    }
    request({
      path: '/monitor/web/cockpitTeam/getCockpitIssueStatistic',
      method: Method.POST,
      body: {
        cockpitTeamNumber: newCommon.cockpitTeamNumber,
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        const { workCockpitList, restCockpitList, offlineCockpitList } =
          res?.data || {};
        setCockpitList({
          ...cockpitList,
          workCockpitList,
          restCockpitList,
          offlineCockpitList,
        });
        timerRef.current = setTimeout(() => {
          clearTimeout(timerRef.current);
          getCockpitGroup();
        }, 5000);
      }
    });
  };

  useEffect(() => {
    getCockpitGroup();
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [newCommon.cockpitTeamNumber]);
  return (
    <div className="cockpit-borad-group">
      <div className="group-item">
        <div className="group-item-head">
          <i className="icon"></i>
          <i className="group-item-label">工作中</i>
        </div>
        <div className="board-list-content">
          {cockpitList?.workCockpitList?.map((item, index: number) => (
            <CockpitBoard
              cockpitStatus={CockpitStatus.WORK}
              {...item}
              key={item.cockpitNumber}
              updateCockpitList={getCockpitGroup}
            />
          ))}
        </div>
      </div>

      <div className="group-item">
        <div className="group-item-head">
          <i className="icon"></i>
          <i className="group-item-label">休息中</i>
        </div>
        <div className="board-list-content">
          {cockpitList?.restCockpitList?.map((item, index: number) => (
            <CockpitBoard
              cockpitStatus={CockpitStatus.REST}
              {...item}
              key={item.cockpitNumber}
            />
          ))}
        </div>
      </div>

      <div className="group-item">
        <div className="group-item-head">
          <i className="icon"></i>
          <i className="group-item-label">离线</i>
        </div>
        <div className="board-list-content">
          {cockpitList?.offlineCockpitList?.map((item, index: number) => (
            <CockpitBoard
              cockpitStatus={CockpitStatus.OFFLINE}
              {...item}
              key={item.cockpitNumber}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CockpitBoardGroup;
